(() => {
  function init(root = document) {
    root.querySelectorAll('[data-lp-occasions]').forEach(section => {
      if (section.dataset.lpOccReady) return;
      const track = section.querySelector('[data-lp-occ-track]');
      if (!track) return;
      section.dataset.lpOccReady = 'true';
      const step = () => track.querySelector('.lp-occ__item').getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
      const advance = direction => track.scrollBy({left: direction * step(), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      section.querySelector('[data-lp-occ-prev]').addEventListener('click', () => advance(-1));
      section.querySelector('[data-lp-occ-next]').addEventListener('click', () => advance(1));
      track.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          advance(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true});
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
